<template functional>
    <div class="w-100 h-100 d-flex justify-content-center align-items-center">
        <div class="text-center" :class="props.innerClass">
            <b-spinner :variant="props.variant" :small="props.small" class="align-middle" :label="$options.getLoadingLabel(parent)"></b-spinner>
            <p v-if="props.text" class="h6 mt-3 mb-0 text-muted">{{props.text}}</p>
        </div>
    </div>
</template>

<script>

// NOTE: this is a FUNCTIONAL component (no `this`), so the usual vue-i18n component
// `i18n` option / $t() cannot be used here. It is also rendered on some pages whose
// root Vue instance has no VueI18n instance (e.g. old rfx templates / iframe pages),
// where $t() would throw. So we keep a local message map and resolve the locale from
// the parent context ($splLocale from the global mixin works even without VueI18n),
// always falling back to English.
const LOADING_LABELS = {
    en: 'Loading...',
    es: 'Cargando...',
    pt: 'Carregando...',
    'zh-Hans': '加载中...',
    'zh-Hant': '載入中...',
};

export default {
    functional: true,
    name: 'BusySpinner',
    components: {},
    getLoadingLabel: function(parent) {
        // called from the functional template via $options (functional comps have no `this`)
        try {
            let locale = (parent && parent.$splLocale) || 'en';
            while (locale) {
                if (LOADING_LABELS[locale]) return LOADING_LABELS[locale];
                const dashIndex = locale.lastIndexOf('-');
                locale = dashIndex > 0 ? locale.slice(0, dashIndex) : '';  // 'zh-Hans-CN' -> 'zh-Hans', 'es-MX' -> 'es'
            }
        } catch (err) {
            // ignore and fall back to English below
        }
        return LOADING_LABELS.en;
    },
    props: {
        small: {  // sets spinner to small size
            type: Boolean,
            default: false,
        },
        variant: {  // BS color variant
            type: String,
            default: 'primary'
        },
        text: {
            type: String,
            default: ''
        },
        innerClass: {  // useful for padding/margin since outide div is w-100 h-100
            type: String,
            required: false,
        }
    },
}
</script>

<style>

</style>